import React from "react";
import { Clock, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const TOUR_IMAGES = [
  "https://images.unsplash.com/photo-1652092521226-3e03a716ae86?crop=entropy&cs=srgb&fm=jpg&w=1200&q=72",
  "https://images.unsplash.com/photo-1602933294670-d068ca54a16a?auto=format&fit=crop&w=1200&q=72",
  "https://images.unsplash.com/photo-1473625247510-8ceb1760943f?auto=format&fit=crop&w=1200&q=72",
  "https://images.unsplash.com/photo-1599320082281-c1f54d49258f?auto=format&fit=crop&w=1200&q=72",
];

const Tours = () => {
  const { t } = useLang();

  return (
    <section
      id="tours"
      data-testid="tours-section"
      className="relative py-24 sm:py-32 bg-[color:var(--bg-secondary)] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="label-eyebrow">{t.tours.eyebrow}</p>
            <h2
              data-testid="tours-title"
              className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 text-white tracking-tight"
            >
              {t.tours.title}
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed">{t.tours.subtitle}</p>
            <p className="mt-3 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[color:var(--gold)]">
              <span className="gold-divider !w-6 !mx-0" />
              {t.tours.priceHint}
            </p>
            <a
              href="#booking"
              data-testid="tours-cta"
              className="btn-gold mt-8 inline-flex"
            >
              {t.tours.cta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {t.tours.cards.map((card, idx) => (
              <article
                key={card.title}
                data-testid={`tour-card-${idx}`}
                className="bento-card group"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={TOUR_IMAGES[idx % TOUR_IMAGES.length]}
                    alt={card.title}
                    className="bento-image w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                  <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 text-[10px] tracking-[0.25em] uppercase text-[color:var(--gold)] bg-black/60 border border-white/10 px-2.5 py-1 backdrop-blur-sm">
                    <Clock className="h-3 w-3" /> {card.duration}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-2xl text-white">{card.title}</h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tours;
